import { Component, Injector, Optional} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {FormsModule} from "@angular/forms";

const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-number',
  hostClass: 'app-input-wrapper'
};

@Component({
  selector: '[wmNumber]',
  template: `<input class="form-control app-textbox app-number-input"
                    inputmode="decimal"
                    [attr.name]="name"
                    role="textbox"
                    type="text"
                    [ngModel]="displayValue"
                    [readonly]="readonly"
                    [disabled]="disabled"
                    [pattern]="regexp"
                    [attr.tabindex]="tabindex"
                    [attr.placeholder]="placeholder"
                    [attr.accesskey]="shortcutkey"
                    [attr.aria-label]="hint || 'Number field'"
                    [autofocus]="autofocus"
                    [required]="required">`,
  providers: [
    provideAsWidgetRef(NumberComponent)
  ],
  exportAs: 'wmNumber',
  standalone: true,
  imports: [CommonModule, FormsModule],
  styles: []
})
export class NumberComponent extends StylableComponent {
  static initializeProps = register('wm-number');

  public name: string;
  public displayValue: string;
  public placeholder: string;
  private proxyModel: number;
  public required: boolean;
  public regexp: string;
  public disabled: boolean;
  public hint: string;
  public tabindex: any;
  public shortcutkey: string;
  public autofocus: boolean;
  public readonly: boolean;
  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  // apply styles to input element and not to div.
  override get stylerEl(): HTMLElement {
    return this.nativeElement.querySelector('input.app-number-input') || this.nativeElement;
  }

  set datavalue(value:number){
    this.proxyModel = value;
    this.displayValue = value.toString();
  }
  get datavalue(){
    return this.proxyModel;
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    let wp: any = this.widgetProps;
    if(key === 'inputmode') {
      wp.decimalplaces.show = nv === 'natural';
    }
    super.onPropertyChange(key, nv, ov);
  }
}

